import styled from "styled-components";
import { MD_SCREEN } from "../util/screen-size";

export const getStyledAboutSectionWrapper = () => styled.div`
    display: flex;
    flex-direction: column;
`

export const getStyledAboutTitle = () => styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    row-gap: 4vh;

    @media (min-width: ${MD_SCREEN}px) {
        flex-direction: row;
        justify-content: space-between;
        text-align: left;
    }

    .about-title{
        font-size: 4em;
        font-family: 'Playfair Display', serif;
    }
    
    .about-description{
        font-size: 1.4em;
        font-weight: 300;
        color: #5F5F64;
        @media (min-width: ${MD_SCREEN}px) {
            width: 30vw;
        }
    }

    .about-button{
        padding: .5em 1.3em;
        background-color: #F4F6F6;
        color: #5F5F64;
        font-size: 1.5em;
        border-radius: .5em;

        cursor: pointer;
    }
`

export const getStyledAboutCardHolder = () => styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 10vh;
    row-gap: 10vh;

    @media (min-width: ${MD_SCREEN}px) {
        flex-direction: row;
        justify-content: space-between;
    }
`

export const getStyledAboutCard = () => styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align:center;
    row-gap: 1vh;
    
    @media (min-width: ${MD_SCREEN}px) {
        align-items: start;
        text-align: left;
    }
    
    .num{
        font-size: 5em;
        font-weight: 600;
        font-family: 'Roboto', sans-serif;
        @media (min-width: ${MD_SCREEN}px) {
            font-size: 4em;
        }
    }
    
    .card-title{
        font-size: 3em;
        font-weight: 600;
        @media (min-width: ${MD_SCREEN}px) {
            font-size: 2em;
        }
    }
    
    .card-description{
        font-size: 1.3em;
        font-weight: 300;
        width: 60vw;
        color: #5F5F64;

        @media (min-width: ${MD_SCREEN}px) {
            font-size: 1.1em;
            width: 15vw;
        }
    }
`

export const getStyledPCColumn = () => styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 4vh;
`